var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-header", attrs: { role: "tab" } }, [
    _c(
      "button",
      {
        staticClass:
          "btn btn-light d-flex justify-content-between align-items-center",
        on: { click: _vm.toggleAccordion },
      },
      [
        _c("div", { staticClass: "module-title" }, [
          _c("span", { staticClass: "material-icons mr-2" }, [
            _vm._v(_vm._s(_vm.moduleIcon)),
          ]),
          _vm._v("\n            " + _vm._s(_vm.moduleName) + "\n        "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("module-toggle", {
              attrs: {
                "is-active": _vm.isModuleFullySelected,
                "is-partial": _vm.isModulePartiallySelected,
              },
              on: { toggle: _vm.toggleAll },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "material-icons module-collapse-icon" }, [
              _vm._v(_vm._s(_vm.isExpanded ? "expand_less" : "expand_more")),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }